import { Button } from "@progress/kendo-react-buttons";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent, DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { defaultDate } from "../Common/Constants";
import Format from "../Common/Util_methods/formatParamOptions";
import { useAppDispatch } from "../Core/store.hooks";
import { getDevicesSelector } from "../Devices/Slice";
import { filterBy } from "@progress/kendo-data-query";
import { getOptionsSelector, updateMdcDrillDown, updateMdcGroupingOptions, updateMdcGroupSize } from "../Common/Slices/optionSlice";
import { mdcApi } from "./mdcApi";
import { addToMdcData, getMdcDataSelector, loadingMdcDataSelector, removeSeries, updateMdcData, updateSelectedSeries } from "./mdcSlice";
import {
    differenceBy, isEqual, orderBy, sortBy,
    isEmpty } from "lodash";
import useRemoveParams from '../Common/hooks/useRemoveParams';
import { useParams } from "react-router-dom";
import getQueryStringParams from "../Common/Util_methods/queryString";
import { Dialog } from "@progress/kendo-react-dialogs";
import GroupingOptions from "./GroupingOptions"; import {
    loginSelector,
    loadingLoginSelector,
    errorLoginSelector,
} from "../Core/Slice";

interface FilterProps {
    id:string;
    seriesFromGrid:any;
}

export interface Series{
    devicesWithSerial: string[];
    deviceTypes:number[];
    deviceName:string;
    deviceNameVersion:string;
    header:string;
}

export interface MachineHealthParams{
    start:string;
    end:string;
    bucketSize:"y" | "M" | "w" | "d";
    seriesObjects:Series[];
}

const initialSeries:Series = {
    devicesWithSerial:[],
    deviceTypes:[],
    deviceName:null,
    deviceNameVersion:null,
    header:null
}

const dataTypes = [
    "Total (Cumulative)",
    "Trend (None Cumulative)",
]
const seriesTypes: string[] = [
    "Device Name",
    "Device Name + Device Size + Version",
];

const Filters = (props: FilterProps) => {

    let startDate = new Date();
    startDate.setDate(startDate.getDate()-7);

    const { queryparams } = useParams();
    let urlParams = getQueryStringParams(queryparams);
    const removeParams = useRemoveParams();
    const [urlParamsDone, setUrlParamsDone] = useState<boolean>(false);
    const [start, setStart] = useState(startDate);
    const [end, setEnd] = useState(new Date);
    const [devices, updateDevices] = useState([]);
    const [countries, updateCountries] = useState([]);
    const [customers, updateCustomers] = useState([]);
    const [country, updateCountry] = useState(null);
    const [customer, updateCustomer] = useState(null);
    const [deviceValue, updateDeviceValue] = useState(null);
    const [selectedUnit, updateSelectedUnit] = useState(null);
    const [unitsLoading, setUnitsLoading] = useState(false);
    const [units, updateUnits] = useState([]);
    //const [selectedSeries, updateSelectedSeries] = useState<Series[]>([initialSeries]);

    const [headerObjects, updateHeaderObjects] = useState([])
    const [headers, updateHeaders] = useState([])
    const [selectedHeader, updateSelectedHeader] = useState(null);
    const [headersLoading, setHeadersLoading] = useState(false);

    const [dataType, updateSelectedDataType] = useState(dataTypes[0])
    const [seriesType, updateSeriesType] = useState("Device Name");

    //const interruptData = useSelector(getInterruptsSelector).interruptData
    const selectedSeries = useSelector(getMdcDataSelector).selectedSeries 
    const deviceObjects = useSelector(getDevicesSelector);
    const options = useSelector(getOptionsSelector)
    const mdcData = useSelector(getMdcDataSelector).mdcData;
    const loadingState = useSelector(loadingMdcDataSelector);
    const dispatch = useAppDispatch();

    const authResponse = useSelector(loginSelector);

    const [loggedIn, updateLoggedIn] = useState<boolean>(false);


    useEffect(() => {
        updateLoggedIn(authResponse);
    }, [authResponse]);


    useEffect(() => {
        if (selectedHeader != null) {
            updateUnits([]);
            updateSelectedUnit(null);
         
            getUnits();
        }
        else {
            updateUnits([]);
            updateSelectedUnit(null);
        }
    }, [selectedHeader]);





    useEffect(()=>{
        if(loggedIn && options.mdcGroupingOptions.length === 0){
            mdcApi.fetchUniqueUnits().then((res)=>{
                dispatch(updateMdcGroupingOptions(res))
            });
        }
    },[loggedIn])
    
    useEffect(()=>{
        if(deviceValue != null){
            let newSeries:Series = {
                devicesWithSerial:[deviceValue],
                deviceTypes:[],
                deviceName:null,
                deviceNameVersion:null,
                header:null
            }
            setHeadersLoading(true);
            mdcApi.fetchHeaders(newSeries).then((res)=>{
                updateHeaderObjects(res);
                setHeadersLoading(false);
            }).catch((error)=>{
                setHeadersLoading(false);
                alert("Error happened while trying to fetch headers")
            })
        }
    },[deviceValue])

    useEffect(()=>{
        if(dataType == dataTypes[0]){
            const headerArr = headerObjects.filter(obj=>obj.cumulativeData).map(obj=>obj.description).sort()
            updateHeaders(headerArr)
            updateSelectedHeader(headerArr[0])
        }else{
            const headerArr = headerObjects.filter(obj=>!obj.cumulativeData).map(obj=>obj.description).sort()
            updateHeaders(headerArr)
            updateSelectedHeader(headerArr[0])
        }
    },[headerObjects,dataType])

    useEffect(()=>{
        if(props.seriesFromGrid != null){
            if(!selectedSeries.some((obj)=>isEqual(obj,props.seriesFromGrid))){
                dispatch(updateSelectedSeries([...selectedSeries,props.seriesFromGrid]))
                let params = {} as MachineHealthParams
                params.start = formatDate(start);
                params.end = formatDate(end);
                params.seriesObjects = [props.seriesFromGrid];
                dispatch(addToMdcData(params))
            }else{
                alert("Series is already selected")
            }
        }
    },[props.seriesFromGrid])

    //useEffect(()=>{
    //    if(options.mdcDrillDown){
    //        updateDrillDown("On")
    //    }else{
    //        updateDrillDown("Off")
    //    }
    //},[options.mdcDrillDown])

    //useEffect(()=>{
    //    if(options.mdcGroupSize === "None"){
    //        let dateRange = end.getTime() - start.getTime();
    //        dateRange = dateRange / (1000 * 60 * 60 * 24);
    //        let groupSize:"None"|"Day"|"Week"|"Month"|"Year"
    //        if (dateRange <= 7){
    //            groupSize = "None";
    //        }
    //        if(dateRange > 7){
    //            groupSize = "Day";
    //        }
    //        if (dateRange >= 50) {
    //            groupSize = "Week";
    //        }
    //        if (dateRange >= 200) {
    //            groupSize = "Month";
    //        }
    //        if (dateRange >= 700) {
    //            groupSize = "Year";
    //        }
    //        if(options.mdcGroupSize !== groupSize){
    //            updateGroupSize(groupSize);
    //            dispatch(updateMdcGroupSize(groupSize));
    //        }
    //    }
    //},[mdcData])

    useEffect(()=>{
        if (loadingState === "rejected") {
            if (selectedSeries != null) {
                if (selectedSeries.length > 0) {
                    alert("Something went wrong, unable to fetch series: " + selectedSeries.at(-1).seriesID);
                    dispatch(removeSeries(selectedSeries.at(-1).seriesID))
                }
            }
        }
    },[loadingState])

    const updateDropDowns = function () {
        updateCountries(Format.Countries(deviceObjects));
        updateCustomers(Format.Customers(deviceObjects, null));
    };

  
   
    const seriesHandler = () =>{
        if(selectedHeader != null && deviceValue != null){
            let newSeries:any = {
                devicesWithSerial:[deviceValue],
                deviceTypes:[],
                deviceName:null,
                deviceNameVersion:null,
                header: selectedHeader,
                unit: selectedUnit
            }
            let params = {
                start:formatDate(start),
                end:formatDate(end),
                seriesObjects:[newSeries]
            }
            newSeries.seriesID = deviceValue + " " + selectedHeader + " (" + selectedUnit+")";
            if(!selectedSeries.some((obj)=>isEqual(obj,newSeries))){
                dispatch(addToMdcData(params))
                dispatch(updateSelectedSeries([...selectedSeries,newSeries]))
            }else{
                alert("Series is already selected")
            }
        }
    }

    const averageSeriesHandler = () =>{
        if(selectedHeader != null){
            const deviceName = Format.findDeviceName(deviceObjects,deviceValue,seriesType)
            let newSeries:any = {
                devicesWithSerial:[],
                deviceTypes:[],
                deviceName:null,
                deviceNameVersion:null,
                header: selectedHeader,
                unit:selectedUnit
            }
            if(seriesType == "Device Name"){
                newSeries.deviceName = deviceName;
            }
            if(seriesType == "Device Name + Device Size + Version"){
                newSeries.deviceTypes = Format.DeviceIDsByDeviceType(deviceObjects,deviceValue);
            }
            let params = {
                start:formatDate(start),
                end:formatDate(end),
                seriesObjects:[newSeries]
            }
            newSeries.seriesID = deviceName + " " + selectedHeader + " " + " (" + selectedUnit + ")";
            if(!selectedSeries.some((obj)=>isEqual(obj,newSeries))){
                dispatch(addToMdcData(params))
                dispatch(updateSelectedSeries([...selectedSeries,newSeries]))
            }else{
                alert("Series is already selected")
            }
        }
    }

    const deviceHandler = function (e: ComboBoxChangeEvent) {
        updateDeviceValue(e.target.value);
        updateHeaders([]);
        updateSelectedHeader(null);
    };

    const seriesTypeHandler = function (e: DropDownListChangeEvent) {
        updateSeriesType(e.target.value);
    };

    const customerHandler = function (e: ComboBoxChangeEvent) {
        updateCustomer(e.target.value);
        updateDeviceValue(null);
        if(e.target.value == null){
            updateDevices([]);
        }else{
            let filteredDevices = Format.DevicesWithSerial(deviceObjects, e.target.value);
            updateDevices(filteredDevices);
            if (filteredDevices.length == 1) {
                updateDeviceValue(filteredDevices[0]);
            }
        }
    };
    const countryHandler = function (e: ComboBoxChangeEvent) {
        updateCountry(e.target.value);
        updateCustomer(null);
        updateDeviceValue(null);
        updateCustomers(Format.Customers(deviceObjects, e.target.value));
        updateDevices([]);
    };

    const drillDownHandler = (e:any) =>{
        //updateDrillDown(e.target.value)
        if(e.target.value==="On"){
            dispatch(updateMdcDrillDown(true));
        }else{
            dispatch(updateMdcDrillDown(false));
        }
    }

    const getUnits = () => {
        setUnitsLoading(true);
        mdcApi
            .fetchUnits({ header: selectedHeader })
            .then((res) => {
                updateUnits(res);
                updateSelectedUnit(res[0])
                setUnitsLoading(false);
            })
            .catch((error) => {
                setUnitsLoading(false);
                alert("Error happened while trying to fetch units");
            });
    }

    const formatDate = (d: any) => {
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;
        return year + "-" + month + "-" + day;
    };

    const comboBoxFilters = () => {
        return {
            countries: (event: ComboBoxFilterChangeEvent) => {
                updateCountries(
                    filterBy(Format.Countries(deviceObjects), event.filter)
                );
            },
            customers: (event: ComboBoxFilterChangeEvent) => {
                updateCustomers(
                    filterBy(
                        Format.Customers(deviceObjects, country),
                        event.filter
                    )
                );
            },
            devices: (event: ComboBoxFilterChangeEvent) => {
               // if (seriesType === "Customer Device") {
                    updateDevices(
                        filterBy(
                            Format.DevicesWithSerial(deviceObjects, customer),
                            event.filter
                        )
                    );
                //}
                //else {
                //    updateDevices(
                //        filterBy(Format.DeviceTypes(deviceObjects, seriesType),
                //            event.filter));
                //}

            },
            headers: (event: ComboBoxFilterChangeEvent) => {
                let headerArr = [];
                if(dataType == dataTypes[0]){
                    headerArr = headerObjects.filter(obj=>obj.cumulativeData).map(obj=>obj.description)
                    //updateSelectedHeader(headerArr[0])
                }else{
                    headerArr = headerObjects.filter(obj=>!obj.cumulativeData).map(obj=>obj.description)
                    updateHeaders(headerArr)
                    //updateSelectedHeader(headerArr[0])
                }
                updateHeaders(filterBy(headerArr,event.filter))
            },
        };
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    return (
        <Fragment>
            
            {/* <div className=" k-textbox-container metricCombo">
                <label className="k-label">Series Type</label>
                <DropDownList
                    popupSettings={{width:"auto"}}
                    data={seriesTypes}
                    value={seriesType}
                    onChange={seriesTypeHandler}
                />
            </div> */}

            <Fragment>
                <div className=" k-textbox-container metricCombo">
                    <label className="k-label">Country</label>
                    <ComboBox
                        data={countries}
                        value={country}
                        onChange={countryHandler}
                        suggest={true}
                        filterable={true}
                        onFilterChange={comboBoxFilters().countries}
                    />
                </div>
                <div className=" k-textbox-container metricCombo">
                    <label className="k-label">Customer</label>
                    <ComboBox
                        popupSettings={{width:"auto"}}
                        data={customers}
                        value={customer}
                        onChange={customerHandler}
                        suggest={true}
                        filterable={true}
                        onFilterChange={comboBoxFilters().customers}
                    />
                </div>
            </Fragment>

            <div className=" k-textbox-container metricCombo">
                <label className="k-label" style={{ width: "300px" }}>
                    Device Name
                </label>
                <ComboBox
                    popupSettings={{width:"auto"}}
                    data={devices}
                    value={deviceValue}
                    onChange={deviceHandler}
                    suggest={true}
                    filterable={true} onFilterChange={comboBoxFilters().devices}
                />
            </div>
            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Data Type</label>
                <DropDownList
                    data={dataTypes}
                    value={dataType}
                    onChange={(e)=>updateSelectedDataType(e.target.value)}
                />
            </div>
            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Header</label>
                <ComboBox
                    popupSettings={{width:"auto"}}
                    data={headers}
                    value={selectedHeader}
                    onChange={(e)=>updateSelectedHeader(e.target.value)}
                    onFilterChange={comboBoxFilters().headers}
                    suggest={true}
                    filterable={true}
                    loading={headersLoading}
                />
            </div>
            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Unit</label>
                <DropDownList
                    data={units}
                    value={selectedUnit}
                    onChange={(e) => updateSelectedUnit(e.target.value)}
                    loading={unitsLoading}
                />
            </div>
            <Button
                className="pp-filter-button"
                onClick={seriesHandler}>
                Add Series
            </Button>

            {dataType == "Trend (None Cumulative)" &&
                    deviceValue != null ? (
                        <Fragment>
                            <div className="pp-sidebar-header">
                                {" "}
                                Add Average Series{" "}
                            </div>
                            <div className=" k-textbox-container metricCombo">
                                <label className="k-label">Series Type</label>
                                <DropDownList
                                    data={seriesTypes}
                                    value={seriesType}
                                    onChange={seriesTypeHandler}
                                    popupSettings={{width:"auto"}}
                                />
                            </div>
                            <Button
                                className="pp-filter-button"
                                onClick={averageSeriesHandler}>
                                Add Series
                            </Button>
                        </Fragment>
                    ) : null}

              
        </Fragment>
    );
};

export default Filters;
